import { getConfig } from '@leagueplatform/core';
import { type NavigateFunction } from '@leagueplatform/routing';
import { SyntheticEvent } from 'react';
import { isExternalUrl } from '@leagueplatform/web-common';

type HandleMasonryLinkOptions = {
  navigate: NavigateFunction;
  url: string;
  state?: unknown;
  event?: SyntheticEvent;
};

export const handleMasonryLink = ({
  navigate,
  url,
  state,
  event,
}: HandleMasonryLinkOptions) => {
  const { config } = getConfig();
  const applicationLinkHandler = config.core?.routing?.handleExternalLink;
  const isDeepLink = url?.startsWith('/');
  const isAppSelectionPrompt =
    url.includes('tel:') || url.includes('mailto:') || url.includes('sms:');

  // Prevent default for all links except those that prompt app selection
  if (!isAppSelectionPrompt) event?.preventDefault();

  // Exit early if the URL provided is undefined or not valid
  if (!url) return;

  if (isDeepLink) {
    // Normalize /care-finder/appointment-scheduling/... → /appointment-scheduling/...
    // Mobile platforms mount scheduling under /care-finder/, but web mounts it
    // as a separate top-level route at /appointment-scheduling/.
    const normalizedUrl = url.startsWith('/care-finder/appointment-scheduling/')
      ? url.replace(
          '/care-finder/appointment-scheduling/',
          '/appointment-scheduling/',
        )
      : url;
    navigate(normalizedUrl, { state });
  } else if (isExternalUrl(url)) {
    // if there is a handler in the app config and the action is an external link, use the custom handler from config
    if (applicationLinkHandler) applicationLinkHandler(url);
    // if there is no custom handler in the config, open an external link in a new tab
    else window.open(url, '_blank', 'noreferrer');
  }
};
